import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import { useInvitationRemoveMutation } from "@/v2-backoffice-client/invitation/remove/invitation.remove.mutation"

export type InvitationRemoveMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  invitationId: number
  onCompleted?(): void
}

function InvitationRemoveMenuItem(props: InvitationRemoveMenuItemProps) {
  const { invitationId, onCompleted, ...menuItemProps } = props

  const [removeInvitation, { loading, error }] = useInvitationRemoveMutation({
    onCompleted,
  })

  return (
    <ActionMenu.ConfirmItem
      iconSrc="trash"
      variant="destructive"
      isLoading={loading}
      error={error}
      errorTitle="Failed to remove invitation"
      confirmTitle="Remove Invitation"
      confirmDescription="Are you sure you want to remove this invitation?"
      confirmText="Remove"
      confirmVariant="destructive"
      onConfirm={async () => {
        await removeInvitation({ variables: { id: invitationId } })
      }}
      {...menuItemProps}
    >
      Remove Invitation
    </ActionMenu.ConfirmItem>
  )
}

export default InvitationRemoveMenuItem
